import { StorageProvider } from './StorageProvider';

export class MemoryStorage implements StorageProvider {
  private store = new Map<string, Uint8Array>();

  async get(key: string): Promise<Uint8Array | null> {
    const data = this.store.get(key);
    if (data === undefined) return null;
    return data.slice();
  }

  async set(key: string, data: Uint8Array): Promise<void> {
    this.store.set(key, data.slice());
  }

  async delete(key: string): Promise<void> {
    this.store.delete(key);
  }

  async list(prefix: string): Promise<string[]> {
    return Array.from(this.store.keys()).filter((k) => k.startsWith(prefix));
  }

  isAvailable(): boolean {
    return true;
  }

  getStorageType(): 'memory' {
    return 'memory';
  }
}
